const config = require('../config.js');

const domain = config.API_URL;
const formUrl = (path, format = 'json') => `${domain}/${path}.${format}`;

export default formUrl;
